/**
 * 模板搜索页 - 搜索引擎缓存页Id
 */

const cacheKey = 'RP_STORE_SEARCH_SCROLLID';

export default {
  version: '1.0',
  key: cacheKey,
  duration: 2 * 60 * 1000,
  get: (key = cacheKey) =>
    window.localStorage && JSON.parse(window.localStorage.getItem(key)),
  set: (value, key = cacheKey) => {
    window.localStorage &&
      window.localStorage.setItem(key, JSON.stringify(value));
  },
  clear: (key = cacheKey) =>
    window.localStorage && window.localStorage.removeItem(key),
};
